import React, { useState, useEffect } from 'react';
import { X, List } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const CreateListModal = ({ onClose, onSubmit }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  // Handle ESC key press to close modal
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    setLoading(true);
    try {
      await onSubmit({ name: name.trim(), description: description.trim() });
    } catch (err) {
      console.error('Error creating list:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            <List size={24} />
            <h2>{t('createNewList')}</h2>
          </div>
          <button onClick={onClose} className="modal-close">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="listName">{t('listNameRequired')}</label>
            <input
              id="listName"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t('listNamePlaceholder')}
              className="form-input"
              autoFocus
              maxLength={100}
            />
          </div>

          <div className="form-group">
            <label htmlFor="listDescription">{t('description')}</label>
            <textarea
              id="listDescription"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder={t('descriptionPlaceholder')}
              className="form-textarea"
              rows={3}
              maxLength={500}
            />
          </div>

          <div className="modal-actions">
            <button 
              type="button" 
              onClick={onClose} 
              className="btn-secondary"
              disabled={loading}
            >
              {t('cancel')}
            </button>
            <button 
              type="submit" 
              className="btn-primary"
              disabled={!name.trim() || loading}
            >
              {loading ? t('creating') : t('createList')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateListModal;
